<template>
  <div>
    <div>
      <div class="main bgmain">
        <div class="listNav">
          <div class="main">
            <i class="iconfont icon-shouye"></i>
            <span>您的位置：</span>
            <span>首页</span>
            <span> > </span>
            <span>教材培训</span>
            <span> > </span>
            <span>教材培训详情</span>
          </div>
        </div>
        <div class="detMain">
          <div class="divtitle">
            <p class="titletext">{{ title }}</p>
          </div>
          <div class="courseCover">
            <div class="videoDiv">
              <video-player
                class="video-player xuanchuanvideo"
                ref="videoPlayerXuan"
                :playsinline="true"
                style="object-fit: fill"
                :options="playerOptionsDiv"
                :x5-video-player-fullscreen="true"
                @pause="onPlayerPause($event)"
                @play="onPlayerPlayDiv($event)"
                @fullscreenchange="onFullscreenChange($event)"
                @click="fullScreen"
                id="video1"
              ></video-player>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { treainDetail } from '../../api/index'
export default {
  data() {
    return {
      playerOptionsDiv: {
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '4:3', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            src: '',
            type: 'video/mp4',
          },
        ],
        poster: '',
        width: '',
        notSupportedMessage: '正在加载中。。。', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          fullscreenToggle: true, //全屏按钮
        },
      },
      id: '',
      title: '',
    }
  },
  created() {
    this.id = this.$route.query.id
    this.getcourseDetail()
  },
  mounted() {},
  methods: {
    getcourseDetail() {
      treainDetail(this.id).then((res) => {
        if (res.status == 0) {
          this.title = res.data.courseName
          this.playerOptionsDiv.sources[0].src = res.data.videoUrl || ''
        }
      })
    },
    // 视频方法
    fullScreen() {
      const player = this.$refs.videoPlayerXuan.player
      player.requestFullscreen() //调用全屏api方法
      player.isFullscreen(true)
      player.play()
    },
    onPlayerPlayDiv(player) {},
    onPlayerPause(player) {},
  },
}
</script>
<style lang="scss">
.titletext {
  color: #333;
  text-align: center;
  font-size: 14px;
}
.divtitle {
  width: 100%;
  height: 40px;
  // background: #000;
  line-height: 40px;
}

.videoDiv {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 20px;

}
.xuanchuanvideo {
  height: 100%;
}
.xuanchuanvideo .video-js {
  height: 100% !important;
  padding-top: 0;
}
.xuanchuanvideo .video-js .vjs-big-play-button {
  width: 46px;
  height: 46px !important;
  border-radius: 50%;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  margin: auto;
  background-color: rgba(43, 51, 63, 0.7) !important;
}
</style>

<style lang="scss" scoped>
.detMain {
  position: absolute;
  top: 150px;
  bottom: 40px;
  width: 1200px;
  // background-color: #000;
}
.courseCover {
  position: absolute;
  top: 40px;
  left: 0px;
  right: 0px;
  bottom: 20px
}
</style>
<style lang="scss">
@import '../../assets/css/mattabs.scss';
</style>
